import { render, staticRenderFns } from "./help-icon.vue?vue&type=template&id=4c9b5c2c&scoped=true"
import script from "./help-icon.vue?vue&type=script&lang=js"
export * from "./help-icon.vue?vue&type=script&lang=js"
import style0 from "./help-icon.vue?vue&type=style&index=0&id=4c9b5c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b5c2c",
  null
  
)

export default component.exports